import "./AboutPage.css"
import "../../App.css"
function AboutPage(){
    return(
        <section name="About Page" className="page-container">
            <div className="row TopSeperator" style={{padding: "0px 20px"}}>
                
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <img className="profile-picture" src="/images/about_icon.png" alt="Profile Picture"/>
                    <hr/>
                    <div className="experience-blurb">
                        <h4>Work Experience</h4>
                        <p>Web Graphic Artist @ <i>Positive Promotions</i></p>
                        <p>Barista Trainer @ <i>Starbucks</i></p>
                        <p>Student Tech @ <i> The University of the Arts</i></p>
                        <hr/>
                        <h4>Education</h4>
                        <p>Bachelor of Fine Arts in Animation</p>
                    </div>
                </div>
                <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1" ></div>
                <div className="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 description-body description-text">
                    <h4>Who Is This Guy?</h4>
                    <p>
                        Though my degree is in animation, I ended up growing a foundness for both game development and art. Art was always a vehicle to express my ideas and fawn over
                        my favorite characters. And game development was tied to my love of games and interactive media. Over the years I grew these two passions
                        by participating in game jams, honing my skills as a programmer, and taking art classes. When it came time to move on from starbucks, Positive Promotions was there to
                        offer me a position, despite my lack of formal education in graphic design and web design. But as I always do, I adpated my knowledge and have excelled in my career.
                        Now I'm going on 3 years as a web designer.
                    </p>
                    <br/>
                    <h4>So What's Your Experience, Mr. Argueta?</h4>
                    <p>
                        Please, call me Jeremy. Currently, I work as a web designer/developer and graphic artist for a b2b company known as Positive Promotions. On the graphic art side of things, I am
                        responsible for doing things like; banners, product images, gateway images and many more graphic imagery. On the web design/development side of things, I plan out the look
                        of pages and blog articles. Construct them via code and do the graphic work for them, tying the page topics into a nice cohesive experience. You can check out the "Work" tab
                        to see what I've done for the company so far.
                    </p>
                    <p>
                        Out of work, you can find me working on games for game jams or toiling away at my solo game dev hobby project, Knife 2 Meet You, a 1v1 blind dodgeball experience. My hobby
                        keeps my skills sharpened as I problem solve many technical issues and concept new ideas, whether they be art or on the programming side of things. Its always a rewarding 
                        experience to work on a problem for hours and then finally having that aha moment and fitting the pieces together. It's a hobby thats given me so much purpose and motivation
                        in life, and blends my two favorite subjects succintly while also introducing other types of media.
                    </p>
                </div>
            </div>
            <div className="row TopSeperator text-center"></div>
        </section>
    );
}

export default AboutPage